import AccountApp from './account-app/account-app.vue';
import HeffronApps from '@/app/constants/account/HeffronApps.json';
import { AppStatus } from '@/app/utils/constants/AppStatus';
import { capitalize } from '@/app/filters/filters';

function setStatus(app, appSubscription, appPermission) {
  if (appSubscription) {
    return appSubscription.status;
  }
  if (appPermission) {
    return appPermission.status;
  }

  return (typeof app.status === 'undefined') ? AppStatus.UNSUBSCRIBED : app.status;
}

export default {
  name: 'account-apps',
  components: {
    AccountApp,
  },
  props: {
    subscriptions: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    apps() {
      const appPermissions = this.$store.getters['account/getAppPermissions'];
      return HeffronApps
        .filter(app => app.appName !== 'ACCOUNT_MANAGEMENT')
        .map((app) => {
          // eslint-disable-next-line max-len
          const appPermission = appPermissions.filter(el => el.appName === app.appName)[0];
          // eslint-disable-next-line max-len
          const appSubscription = this.subscriptions.filter(sub => sub.plan.metadata.APP === app.appName)[0];
          const status = setStatus(app, appSubscription, appPermission);

          return {
            ...app,
            ...appPermission,
            status,
            subscriptionID: appSubscription ? appSubscription.id : null,
            hasCancel: appSubscription ? appSubscription.cancel_at_period_end : false,
            cancelAt: appSubscription ? appSubscription.cancel_at : null,
            currentSub: appSubscription ? (typeof appSubscription.current_period_end === 'number' || app.status === AppStatus.PENDING) : false,
            currentUntil: appSubscription ? appSubscription.current_period_end : null,
            level: appSubscription ? capitalize(appSubscription.level) : 'Base',
            // eslint-disable-next-line no-unneeded-ternary
            canEditSubQty: (appSubscription && (app.appName === 'COMPANION' || app.appName === 'BITES')) ? true : false,
            qty: appSubscription ? appSubscription.quantity : 1,
          };
        });
    },
  },
  watch: {
    subscriptions: {
      immediate: true,
      handler() {
        this.loading = false;
      },
    },
  },
};
